import { AbilityBuilder } from '@casl/ability';

export default AbilityBuilder.define((can: any) => {
    // pass
});
